<template>
  <!-- 尾部导航栏 -->
  <div class="group_13 flex-col justify-end">
    <!-- <div class="group_14 flex-row">
      <span class="text_33">电池护照网</span>
      <span class="text_34">微信公众号</span>
      <span class="text_35">联系我们</span>
      <div class="section_12 flex-col"></div>
    </div> -->
    <div class="group_15 flex-row">
      <div class="image-wrapper_1 flex-col">
        <div class="image_title"><span>电池护照网</span></div>
        <img alt="" :class="[$webType == 'cbia' ? 'image_cbia' : 'image_20']" referrerpolicy="no-referrer"
          :src="$webType == 'cbia' ? cbiaIconLogo : IconLogo" />
      </div>
      <div class="image-wrapper_3">
        <div class="image_box">
          <img class="label_7" referrerpolicy="no-referrer" :src="serviceIcon" alt="" />
          <div class="image_text"><span>CBIA官方服务号</span></div>
        </div>
        <div class="image_box">
          <img class="label_7" referrerpolicy="no-referrer" :src="registerIcon" alt="" />
          <div class="image_text"><span>CBIA官方订阅号</span></div>
        </div>
      </div>
      <div class="group_16_wrapper">
        <div class="group_16_title"><span>联系我们</span></div>
        <div class="justify-between">
          <div class="group_16 flex-col">
            <div class="block_5 flex-row justify-between">
              <img class="label_8" referrerpolicy="no-referrer" :src="addressIcon" alt="" />
              <span class="text_36">中国北京市西城区红莲南路57号中国文化大厦东门9层</span>
            </div>
            <div class="image-text_11 flex-row justify-between">
              <img class="label_9" referrerpolicy="no-referrer" :src="phoneIcon" alt="" />
              <span class="text-group_11">010-63385179</span>
            </div>
          </div>
          <!-- <div class="group_16_one flex-col">
            <div class="flex-row">
              <img class="thumbnail_4" referrerpolicy="no-referrer" :src="czjIcon" alt="" />
              <span class="text_37">010-63385079</span>
            </div>
            <div class="image-text_11 flex-row">
              <img class="thumbnail_4" referrerpolicy="no-referrer" :src="emailIcon" alt="" />
              <span class="text_37">cbialijiayu@163.com</span>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="group_17 flex-col"></div>
    <div class="text-wrapper_10 flex-row">
      <span class="text_38">友情链接</span>
      <span class="text_39" @click="convertLoad('https://www.miit.gov.cn/')">中华人民共和国工业和信息化部</span>
      <span class="text_40" @click="convertLoad('http://www.caict.ac.cn/')">中国信息通信研究院</span>
      <span class="text_41" @click="convertLoad('https://www.idfactory.cn/')">中国工业互联网顶级节点</span>
    </div>
    <div class="text-wrapper_11 flex-row">
      <span class="text_42">Copyright © 2023 &nbsp; &nbsp; 南京复创智能制造技术有限责任公司 |
        <span class="copyright_active"
          @click="convertLoad('https://beian.miit.gov.cn/')">苏ICP备2022027126号-7</span></span>
    </div>
  </div>
</template>
<script>
import IconLogo from "@/assets/images/portal/logo.png";
import cbiaIconLogo from "@/assets/images/portal/cbiaLogo.png";
import commpanyIcon from "@/assets/images/footerNav/commpany_icon.png";
import addressIcon from "@/assets/images/footerNav/address_icon.png";
import emailIcon from "@/assets/images/footerNav/email_icon.png";
import phoneIcon from "@/assets/images/footerNav/phone_icon.png";
import czjIcon from "@/assets/images/footerNav/czj_icon.png";
import serviceIcon from "@/assets/images/home/serviceQrcode.png";
import registerIcon from "@/assets/images/home/registerQrcode.png";
export default {
  name: "webFooterNav",
  data() {
    return {
      IconLogo,
      cbiaIconLogo,
      commpanyIcon,
      addressIcon,
      emailIcon,
      phoneIcon,
      czjIcon,
      serviceIcon,
      registerIcon
    };
  },
  methods: {
    convertLoad(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>
